import { analysisDescription } from "./functions";

export const teamNames = [
  "Recreational Renegades",
  "Sunday Hoopers",
  "Ballin' Buddies",
  "Fast Break Fanatics",
  "Slammin' Squad",
  "Jump Shot Junkies",
  "Full Court Pressers",
  "Pickup Players",
  "Rim Rockers",
  "Swish City",
  "Net Ninjas",
  "Fast Lane Ballers",
  "Slammin' Sensations",
  "Three Point Titans",
  "Dunk Dynasty",
  "Rebound Rebels",
  "Assist Avengers",
  "Steal Squad",
  "Block Party",
  "Free Throw Fanatics",
  "Defense Dynamos",
  "Offense Overload",
  "Recreational Renegades",
  "Sunday Showdowns",
  "Ballin' Brigade",
];
export const barChartData = {
  di: {
    //Div I
    ball_handling: [
      {
        name: "NBA",
        games: 2,
      },
      {
        name: "High Major",
        games: 11,
      },
      {
        name: "DI",
        games: 15,
      },
      {
        name: "DII/III",
        games: 6,
      },
      {
        name: "Juco",
        games: 1,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    scoring: [
      {
        name: "NBA",
        games: 2,
      },
      {
        name: "High Major",
        games: 7,
      },
      {
        name: "DI",
        games: 12,
      },
      {
        name: "DII/III",
        games: 9,
      },
      {
        name: "Juco",
        games: 2,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    playmaking: [
      {
        name: "NBA",
        games: 0,
      },
      {
        name: "High Major",
        games: 7,
      },
      {
        name: "DI",
        games: 11,
      },
      {
        name: "DII/III",
        games: 5,
      },
      {
        name: "Juco",
        games: 2,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    rebounding: [
      {
        name: "NBA",
        games: 0,
      },
      {
        name: "High Major",
        games: 3,
      },
      {
        name: "DI",
        games: 15,
      },
      {
        name: "DII/III",
        games: 11,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    defense: [
      {
        name: "NBA",
        games: 0,
      },
      {
        name: "High Major",
        games: 6,
      },
      {
        name: "DI",
        games: 12,
      },
      {
        name: "DII/III",
        games: 7,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
  },
  high_major: {
    //High Major
    ball_handling: [
      {
        name: "NBA",
        games: 4,
        game_details: [
          { opponent: "Hoops and Dreams", date: "2022-10-20" },
          { opponent: "Court Kings", date: "2022-10-25" },
          { opponent: "Full Court Press", date: "2022-10-30" },
          { opponent: "Swish Squad", date: "2022-11-01" },
        ],
      },
      {
        name: "High Major",
        games: 11,
        game_details: [
          { opponent: "Hoops and Dreams", date: "2022-10-20" },
          { opponent: "Court Kings", date: "2022-10-25" },
          { opponent: "Full Court Press", date: "2022-10-30" },
          { opponent: "Swish Squad", date: "2022-11-01" },
          { opponent: "Rolling Hills", date: "2022-11-02" },
          { opponent: "Davis", date: "2022-11-03" },
          { opponent: "Rolling Hills", date: "2022-11-04" },
          { opponent: "Davis", date: "2022-11-05" },
          { opponent: "Rolling Hills", date: "2022-11-06" },
          { opponent: "Davis", date: "2022-11-07" },
          { opponent: "Rolling Hills", date: "2022-11-08" },
          { opponent: "Davis", date: "2022-11-09" },
        ],
      },
      {
        name: "DI",
        games: 5,
        game_details: [
          { opponent: "Hoops and Dreams", date: "2022-10-20" },
          { opponent: "Court Kings", date: "2022-10-25" },
          { opponent: "Full Court Press", date: "2022-10-30" },
          { opponent: "Swish Squad", date: "2022-11-01" },
          { opponent: "Rolling Hills", date: "2022-11-02" },
        ],
      },
      {
        name: "DII/III",
        games: 3,
        game_details: [
          { opponent: "Hoops and Dreams", date: "2022-10-20" },
          { opponent: "Court Kings", date: "2022-10-25" },
          { opponent: "Full Court Press", date: "2022-10-30" },
        ],
      },
      {
        name: "Juco",
        games: 0,
        game_details: [],
      },
      {
        name: "HS",
        games: 0,
        game_details: [],
      },
    ],
    scoring: [
      {
        name: "NBA",
        games: 5,
      },
      {
        name: "High Major",
        games: 14,
      },
      {
        name: "DI",
        games: 9,
      },
      {
        name: "DII/III",
        games: 2,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    playmaking: [
      {
        name: "NBA",
        games: 3,
      },
      {
        name: "High Major",
        games: 16,
      },
      {
        name: "DI",
        games: 8,
      },
      {
        name: "DII/III",
        games: 4,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    rebounding: [
      {
        name: "NBA",
        games: 7,
      },
      {
        name: "High Major",
        games: 15,
      },
      {
        name: "DI",
        games: 9,
      },
      {
        name: "DII/III",
        games: 1,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    defense: [
      {
        name: "NBA",
        games: 4,
      },
      {
        name: "High Major",
        games: 12,
      },
      {
        name: "DI",
        games: 5,
      },
      {
        name: "DII/III",
        games: 6,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
  },
  nba: {
    //NBA
    ball_handling: [
      {
        name: "NBA",
        games: 14,
      },
      {
        name: "High Major",
        games: 11,
      },
      {
        name: "DI",
        games: 5,
      },
      {
        name: "DII/III",
        games: 1,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    scoring: [
      {
        name: "NBA",
        games: 12,
      },
      {
        name: "High Major",
        games: 9,
      },
      {
        name: "DI",
        games: 5,
      },
      {
        name: "DII/III",
        games: 0,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    playmaking: [
      {
        name: "NBA",
        games: 13,
      },
      {
        name: "High Major",
        games: 10,
      },
      {
        name: "DI",
        games: 2,
      },
      {
        name: "DII/III",
        games: 0,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    rebounding: [
      {
        name: "NBA",
        games: 14,
      },
      {
        name: "High Major",
        games: 10,
      },
      {
        name: "DI",
        games: 1,
      },
      {
        name: "DII/III",
        games: 0,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
    defense: [
      {
        name: "NBA",
        games: 12,
      },
      {
        name: "High Major",
        games: 111,
      },
      {
        name: "DI",
        games: 5,
      },
      {
        name: "DII/III",
        games: 0,
      },
      {
        name: "Juco",
        games: 0,
      },
      {
        name: "HS",
        games: 0,
      },
    ],
  },
};

const lineData = {
  di: {
    //Div I
    ball_handling: [
      { name: "11/19", date: 77 },
      { name: "11/23", date: 67 },
      { name: "11/29", date: 75 },
      { name: "11/30", date: 80 },
      { name: "12/3", date: 88 },
      { name: "12/14", date: 93 },
      { name: "12/15", date: 85 },
    ],
    playmaking: [
      { name: "11/19", date: 77 },
      { name: "11/23", date: 82 },
      { name: "11/29", date: 85 },
      { name: "11/30", date: 88 },
      { name: "12/3", date: 91 },
      { name: "12/14", date: 94 },
      { name: "12/15", date: 95 },
    ],
    scoring: [
      { name: "11/19", date: 79 },
      { name: "11/23", date: 84 },
      { name: "11/29", date: 87 },
      { name: "11/30", date: 89 },
      { name: "12/3", date: 92 },
      { name: "12/14", date: 93 },
      { name: "12/15", date: 90 },
    ],
    rebounding: [
      { name: "11/19", date: 84 },
      { name: "11/23", date: 79 },
      { name: "11/29", date: 87 },
      { name: "11/30", date: 71 },
      { name: "12/3", date: 82 },
      { name: "12/14", date: 89 },
      { name: "12/15", date: 78 },
    ],
    defense: [
      { name: "11/19", date: 82 },
      { name: "11/23", date: 78 },
      { name: "11/29", date: 85 },
      { name: "11/30", date: 88 },
      { name: "12/3", date: 84 },
      { name: "12/14", date: 81 },
      { name: "12/15", date: 87 },
    ],
  },
  high_major: {
    //High Major
    ball_handling: [
      { name: "11/19", date: 77 },
      { name: "11/23", date: 87 },
      { name: "11/29", date: 95 },
      { name: "11/30", date: 90 },
      { name: "12/3", date: 92 },
      { name: "12/14", date: 89 },
      { name: "12/15", date: 80 },
    ],
    playmaking: [
      { name: "11/19", date: 87 },
      { name: "11/23", date: 89 },
      { name: "11/29", date: 91 },
      { name: "11/30", date: 92 },
      { name: "12/3", date: 93 },
      { name: "12/14", date: 94 },
      { name: "12/15", date: 95 },
    ],
    scoring: [
      { name: "11/19", date: 87 },
      { name: "11/23", date: 92 },
      { name: "11/29", date: 89 },
      { name: "11/30", date: 91 },
      { name: "12/3", date: 94 },
      { name: "12/14", date: 96 },
      { name: "12/15", date: 97 },
    ],
    rebounding: [
      { name: "11/19", date: 87 },
      { name: "11/23", date: 89 },
      { name: "11/29", date: 91 },
      { name: "11/30", date: 92 },
      { name: "12/3", date: 93 },
      { name: "12/14", date: 94 },
      { name: "12/15", date: 95 },
    ],
    defense: [
      { name: "11/19", date: 87 },
      { name: "11/23", date: 92 },
      { name: "11/29", date: 89 },
      { name: "11/30", date: 91 },
      { name: "12/3", date: 94 },
      { name: "12/14", date: 96 },
      { name: "12/15", date: 97 },
    ],
  },
  nba: {
    //NBA
    ball_handling: [
      { name: "11/19", date: 95 },
      { name: "11/23", date: 98 },
      { name: "11/29", date: 96 },
      { name: "11/30", date: 97 },
      { name: "12/3", date: 99 },
      { name: "12/14", date: 100 },
      { name: "12/15", date: 98 },
    ],
    playmaking: [
      { name: "11/19", date: 96 },
      { name: "11/23", date: 97 },
      { name: "11/29", date: 98 },
      { name: "11/30", date: 99 },
      { name: "12/3", date: 100 },
      { name: "12/14", date: 95 },
      { name: "12/15", date: 96 },
    ],
    scoring: [
      { name: "11/19", date: 95 },
      { name: "11/23", date: 96 },
      { name: "11/29", date: 97 },
      { name: "11/30", date: 98 },
      { name: "12/3", date: 99 },
      { name: "12/14", date: 100 },
      { name: "12/15", date: 85 },
    ],
    rebounding: [
      { name: "11/19", date: 96 },
      { name: "11/23", date: 97 },
      { name: "11/29", date: 98 },
      { name: "11/30", date: 99 },
      { name: "12/3", date: 100 },
      { name: "12/14", date: 95 },
      { name: "12/15", date: 94 },
    ],
    defense: [
      { name: "11/19", date: 96 },
      { name: "11/23", date: 97 },
      { name: "11/29", date: 98 },
      { name: "11/30", date: 99 },
      { name: "12/3", date: 100 },
      { name: "12/14", date: 95 },
      { name: "12/15", date: 96 },
    ],
  },
};

export const lineChart = (type, score) => {
  let level = analysisDescription(score).label;
  if (!lineData[level]) {
    level = "di";
  }

  return lineData[level][type];
};
export const barChart = (type, score) => {
  let level = analysisDescription(score).label;
  if (!barChartData[level]) {
    level = "di";
  }
  return barChartData[level][type];
};

export const analysisBest = (level, type) => {
  // Use default player if the requested player doesn't exist in demoAnalysis
  const playerData = barChartData[level] || barChartData.di;

  // Get the relevant array based on the type (defense, scoring, etc.)
  const data = playerData[type];

  // Calculate total games
  const totalGames = data.reduce((sum, level) => sum + level.games, 0);

  // Find the level with most games
  const bestLevel = data.reduce(
    (max, level) => (level.games > max.games ? level : max),
    data[0]
  );

  // Calculate percentage (rounded to nearest whole number)
  const percentage =
    totalGames === 0 ? 0 : Math.round((bestLevel.games / totalGames) * 100);

  return {
    level: bestLevel.name,
    games: bestLevel.games,
    percentage,
  };
};
export const nilChart = [
  { date: "May 24", amount: 350 },
  { date: "Jun 24", amount: 300 },
  { date: "Jul 24", amount: 400 },
  { date: "Aug 24", amount: 600 },
  { date: "Sep 24", amount: 550 },
  { date: "Oct 24", amount: 550 },
  { date: "Nov 24", amount: 550 },
  { date: "Dec 24", amount: 450 },
  { date: "Jan 25", amount: 450 },
];
